export function commercialReaRequest(state = {
    fetching:false,
    fetched: false,
    error:null,
},{
    type,
    payload
}){
    
    switch(type){
        case "CREATE_COMMERCIAL_REA_START":           
        case "FETCH_COMMERCIAL_REAS_START":           
        case "DELETE_COMMERCIAL_REA_START":           
        case "FETCH_INIT_DATA2_START":           
        case "FETCH_INIT_DATA3_START":           
            return {
                ...state, 
                fetching:true
            }        
        case "CREATE_COMMERCIAL_REA_FULFILLED":           
        case "FETCH_COMMERCIAL_REAS_FULFILLED":           
        case "DELETE_COMMERCIAL_REA_FULFILLED":           
        case "FETCH_INIT_DATA3_FULFILLED":           
            return {
                ...state,
                fetching:false, 
                fetched:true, 
                error: null
            }    
        case "CREATE_COMMERCIAL_REA_ERROR":
        case "FETCH_COMMERCIAL_REAS_ERROR":
        case "DELETE_COMMERCIAL_REA_ERROR":
        case "FETCH_INIT_DATA3_ERROR":
            return {
                ...state,
                fetching:false, 
                error:payload
            }
        default:
            return state;
    }
    
}